import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Button, Row } from "react-bootstrap";
import "../../components/button/button.css";
import Image from "../../assets/qrcodePlace.png";

const QrcodePlace = () => {
  const navigate = useNavigate();

  return (
    <>
      <Container
        fluid
        className="vh-100 d-flex flex-column"
        style={{ minHeight: "100vh" }}
      >
        <Row
          style={{ height: "15%" }}
          className="d-flex justify-content-center  align-items-center mt-2 mb-2"
        >
          <div>
            <div className="text-center" style={{ color: "#00867F" }}>
              <p className="display-1">
                <b>?</b>
              </p>
              <p className="display-1">
                <b>輸入機器號碼</b>
              </p>
            </div>
          </div>
        </Row>

        <Row
          style={{ height: "25%", textAlign: "center" }}
          className="text-center mt-1"
        >
          <img
            src={Image}
            alt="codePlace"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
          />
        </Row>
        <Row style={{ height: "25%" }} className="m-3">
          <ul style={{ width: `90%`, margin: "10% auto" }}>
            <li>
              <p className="h5">
                <b>找到您機器上的仿單(通常在設備的操作面板或側面板金附近)，掃描上面的QRcode即可</b>
              </p>
            </li>
            <br></br>
            <li>
              <p className="h5">
                <b>此登錄方式僅限改版後仿單，若您的仿單上無QRcode，請改手動輸入方式登錄</b>
              </p>
            </li>
          </ul>
        </Row>

        <Row className="text-center m-3 ">
          <Button
            className="mt-5 w-50 btn-custom-green "
            style={{ margin: " auto" }}
            onClick={() => {
              if (window.history.length <= 1) navigate("/main");
              else navigate(-1);
            }}
          >
            確認
          </Button>
        </Row>
      </Container>
    </>
  );
};

export default QrcodePlace;
